/* eslint-disable typescript-sort-keys/string-enum */

export enum PurchasesCompleteStatusTypes {
	All = 'allStatus',
	AwaitingConfirmation = 'awaitingConfirmation',
	ReviewingDocs = 'reviewingDocs',
	ChecksComplete = 'checksComplete',
	DeliveryRequested = 'deliveryRequested',
}

/* eslint-enable typescript-sort-keys/string-enum */
